import { TravelItem } from "components";

import styles from "./styles.module.scss";

export default function ExtractPage() {
	const months = [
		"Janeiro",
		"Fevereiro",
		"Março",
		"Abril",
		"Maio",
		"Junho",
		"Julho",
		"Agosto",
		"Setembro",
		"Outubro",
		"Novembro",
		"Dezembro"
	];

	const travels = [
		{
			id: "1",
			departure: "São Paulo",
			arrival: "São Sebastião",
			payment: "PIX",
			date: "10/06/2025",
			price: "R$ 1.250,00"
		},
		{
			id: "2",
			departure: "São Paulo",
			arrival: "Bertioga",
			payment: "PIX",
			date: "10/06/2025",
			price: "R$ 2.250,00"
		},
		{
			id: "3",
			departure: "São Paulo",
			arrival: "Guarujá",
			payment: "PIX",
			date: "10/06/2025",
			price: "R$ 1.500,00"
		},
		{
			id: "4",
			departure: "São Paulo",
			arrival: "Ilha Bela",
			payment: "PIX",
			date: "10/06/2025",
			price: "R$ 1.400,00"
		}
	];

	return (
		<div className={styles.container}>
			<div className={styles.extractHeader}>
				<span>Extrato</span>
			</div>
			<div className={styles.extractMonth}>
				{months.map((month) => (
					<div className={styles.monthItem}>
						<span>{month}</span>
					</div>
				))}
			</div>
			<div className={styles.extractPannel}>
				<span>Total</span>
				<span>R$ 5.000,00</span>
			</div>
			<div className={styles.extractContent}>
				<span>Histórico de pagamentos</span>
				{travels.map((travel) => (
					<TravelItem
						arrival={travel.arrival}
						departure={travel.departure}
						paymentType={travel.payment}
						paymentDate={travel.date}
						price={travel.price}
					/>
				))}
			</div>
		</div>
	);
}
